export enum documentState {
	outgoing = "outgoing",
	incoming = "incoming",
	draft = "draft",
	all = "all",
	waitingForProcessing = "waiting_for_processing",
	atPartner = "at_partner",
	completed = "completed"
}
